import useAuthUser from "../../hooks/useAuthUser";
import Long from "./potential/long";
import Short from "./potential/short";

export default function Potential(props) {
    const { user } = useAuthUser();

    return user.version_pk === 'Panjang' ? (
        <Long {...props} />
    ) : (
        <Short {...props} />
    )
}